/**
 * Semantic linter rule for RetargetModifier3D: Godot's own configuration warning "There is no child
 * Skeleton3D!" (retarget_modifier_3d.cpp:33-39) when `child_skeletons` is empty. No key on the node
 * decides this tree shape, so it is a rule, not a validator. Godot warns itself: the scene loads
 * and the node is inert.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { hasChildOfType } from '../../../../linter/childType.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../linter/ruleArms.js';
const arms = {
    noChildSkeleton: groundedArm('retargetmodifier3d-no-child-skeleton', { kind: 'configuration-warning' }),
};
function checkRetargetModifier3D(context) {
    const { node } = context;
    const children = node.children;
    // `_update_child_skeletons` (retarget_modifier_3d.cpp:175-191) keeps only the direct children
    // `Object::cast_to<Skeleton3D>` accepts (:180), so a deeper skeleton is never collected. A child
    // whose class lives elsewhere may be one, so it silences the rule.
    if (hasChildOfType(node, ['Skeleton3D']))
        return [];
    const what = children.length === 0
        ? 'has no children'
        : `has only ${children.map((child) => child.type).join(', ')} as children`;
    return [
        armDiagnostic(arms.noChildSkeleton, node, `RetargetModifier3D '${node.name}' ${what}. It retargets the parent skeleton's pose onto Skeleton3D nodes placed directly beneath it, so with none there it collects no target and modifies nothing.`),
    ];
}
const retargetModifier3DChildSkeletonRule = {
    meta: {
        name: 'valid-retargetmodifier3d-child-skeleton',
        description: 'Warns when a RetargetModifier3D has no direct child Skeleton3D to retarget onto, the state Godot itself reports as "There is no child Skeleton3D!"',
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'RetargetModifier3D'),
        emits: armEmits(arms),
    },
    check: checkRetargetModifier3D,
};
ruleRegistry.register(retargetModifier3DChildSkeletonRule);
//# sourceMappingURL=linter.js.map